import { useMemo } from 'react';

import { RelevanceOptions } from '../../../constants/filterOptions';
import { Relevance } from '../../../types';
import TooltipIcon from '../../atoms/TooltipIcon';
import Dropdown from '../../molecules/Dropdown';

interface RelevanceDropdownProps {
  value: Relevance;
  updateRelevance: (value: Relevance) => void;
  isLoading: boolean;
  title?: string;
}

export const RelevanceDropdown = ({ value, updateRelevance, isLoading, title }: RelevanceDropdownProps) => {
  const relevanceOptions = useMemo(() => {
    return Object.values(RelevanceOptions).map((option) => ({
      label: option.label,
      key: option.value,
    }));
  }, []);

  return (
    <div>
      <div className="mb-1 flex items-center gap-1 font-semibold text-gray-800">
        {title || 'Relevant'}
        <TooltipIcon tooltipContent="Is this fact relevant to the key case issues?" />
      </div>
      <div
        className={`${
          {
            [Relevance.Relevant]: 'text-green-600',
            [Relevance.NotRelevant]: 'text-red-500',
            [Relevance.MaybeRelevant]: 'text-orange-400',
          }[value] ?? ''
        }`}
      >
        <Dropdown<Relevance>
          id="relevance"
          placeholder="Select Relevance"
          options={relevanceOptions}
          onOptionClick={updateRelevance}
          value={value}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};
